// extracted by mini-css-extract-plugin
export default {"loadingWrap":"Loading_loadingWrap__2QzDz"};